import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[headerButton]',
})
export class HeaderButtonDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}